module.exports = __webpack_public_path__ + "static/img/22.33499ccf.png";